import { useState } from 'react';
import { usePagination } from 'further-ui/hooks';
import { useOrganisationLinkedSubscriptions } from 'hooks/data/organisation/useOrganisationLinkedSubscriptions';

export const useLinkedInvestments = (organisationId?: string) => {
  const [search, setSearch] = useState<string>('');
  const pagination = usePagination({
    id: `organisation-linked-subscriptions-${organisationId}`,
  });

  const { data, isFetching } = useOrganisationLinkedSubscriptions({
    organisationId,
    params: {
      search,
      page: pagination.page,
      pageSize: pagination.rowsPerPage,
      orderBy: pagination.orderBy,
      order: pagination.order,
    },
  });

  const handleSearch = (value: string) => {
    setSearch(value);
    pagination.toFirstPage();
  };

  return {
    search,
    handleSearch,
    pagination,
    data,
    isFetching,
  };
};
